import { useCallback, useEffect, useState } from "react";
import { getSsoSettings } from "../../../services/SsoService";

// The Company sign-in tab's details, read again after each change.
export const useSsoSettings = () => {
  const [settings, setSettings] = useState(null);
  const [failed, setFailed] = useState(false);

  const reload = useCallback(async () => {
    try {
      const ajax = await getSsoSettings();
      setSettings(ajax.data?.response || null);
      setFailed(false);
    } catch (error) {
      setFailed(true);
    }
  }, []);

  useEffect(() => {
    reload();
  }, [reload]);

  return { settings, failed, reload };
};

export default useSsoSettings;
